// extracted by css-extract-rspack-plugin
export default {"content":"_f5d4ae9a","topWrapper":"_f609a56b"};